"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SequentialCorrelationIdHandler = void 0;
class SequentialCorrelationIdHandler {
    constructor() {
        this._currentValue = 0;
    }
    increment() {
        return (this._currentValue++);
    }
    getCurrentValue() {
        return this._currentValue;
    }
}
exports.SequentialCorrelationIdHandler = SequentialCorrelationIdHandler;
//# sourceMappingURL=sequential-correlation-id-handler.js.map